// extracted by mini-css-extract-plugin
export default {"root":"_2JKng","content":"_2ypu-","head":"_3tyYN"};